import { BASE_FONT_SIZE, BASE_WINDOW_HEIGHT, BASE_WINDOW_WIDTH } from '@/constant'

const state = {
  fullscreen: false,
  remFactor: BASE_FONT_SIZE,
  showSideMenu: true,
  isLongHeader: true,
  innerWidth: 0
}

const getters = {
  remToPixel: (state) => (rem) => {
    return state.fullscreen ? rem * state.remFactor : rem * BASE_FONT_SIZE
  },
  designPixelToAbsolutePixel: (state) => (pixel) => {
    return state.fullscreen ? pixel / BASE_FONT_SIZE * state.remFactor : pixel
  }
}

const actions = {

}

const mutations = {
  updateFullScreenByVar(state, isFullscreen) {
    // 不再能够退出fullscreen
    state.fullscreen = isFullscreen
  },
  updateShowSideMenu(state, value) {
    state.showSideMenu = value
  },
  updateIsLongHeader(state, value) {
    state.isLongHeader = value
  },
  resizeWindow(state) {
    state.innerWidth = window.innerWidth
    const windowHWRate = window.innerHeight / window.innerWidth
    const baseHWRate = BASE_WINDOW_HEIGHT / BASE_WINDOW_WIDTH
    if (windowHWRate < baseHWRate) {
      state.remFactor = window.innerHeight * BASE_FONT_SIZE / BASE_WINDOW_HEIGHT
    } else {
      state.remFactor = window.innerWidth * BASE_FONT_SIZE / BASE_WINDOW_WIDTH
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/screen/index.js